import { formatPeriodoInforme } from '../helpers'

/**
 * Formatea valores porcentuales según los criterios:
 * - Usa coma (,) como separador decimal
 * - Muestra 0 antes de la coma para valores < 1%
 * - Mantiene el símbolo % al final
 */
const formatPercentage = (value) => {
  if (value === null || value === undefined || value === '') return ''

  // Convertir a string y reemplazar punto por coma
  let formatted = String(value).replace('.', ',')

  // Si comienza con coma, agregar 0 antes (ej: ,47% -> 0,47%)
  if (formatted.startsWith(',')) {
    formatted = '0' + formatted
  }

  // Asegurar que termine con %
  if (!formatted.endsWith('%')) {
    formatted += '%'
  }

  return formatted
}

export const buildEvolucionRows = (data) => {
  if (!data || data.length === 0) {
    return `<tr><td colspan="10" class="empty-msg">No se registran siniestros para el período seleccionado.</td></tr>`
  }
  return data
    .map(
      (r, i) => `
    <tr class="${i % 2 === 1 ? 'alt' : ''}">
      <td style="text-align:center;">${formatPeriodoInforme(r.periodo)}</td>
      <td style="text-align:center;">${r.empleados ?? ''}</td>
      <td style="text-align:center;">${r.siniestrosLt ?? ''}</td>
      <td style="text-align:center;">${r.siniestrosIi ?? ''}</td>
      <td style="text-align:center;">${r.siniestrosEp ?? ''}</td>
      <td style="text-align:center;">${r.siniestros ?? ''}</td>
      <td style="text-align:center;">${formatPercentage(r.incLt)}</td>
      <td style="text-align:center;">${formatPercentage(r.incIi)}</td>
      <td style="text-align:center;">${formatPercentage(r.incEp)}</td>
      <td style="text-align:center;">${formatPercentage(r.incTotal)}</td>
    </tr>`
    )
    .join('')
}

export const buildPersonasRows = (data, emptyMsg) => {
  if (!data || data.length === 0) {
    return `<tr><td colspan="9" class="empty-msg" style="height:56px;">${emptyMsg}</td></tr>`
  }
  return data
    .map(
      (r, i) => `
    <tr class="${i % 2 === 1 ? 'alt' : ''}">
      <td style="text-align:center;">${r.cuil ?? ''}</td>
      <td>${r.nombre ?? ''}</td>
      <td style="text-align:center;">${r.cantidad ?? ''}</td>
      <td style="text-align:center;">${r.lugarTrabajo ?? ''}</td>
      <td style="text-align:center;">${r.inItinere ?? ''}</td>
      <td style="text-align:center;">${r.efProf ?? ''}</td>
      <td style="text-align:center;">${r.juicios ?? ''}</td>
      <td style="text-align:center;">${r.cantAutodenuncia ?? ''}</td>
      <td style="text-align:center;">${r.activo ? 'Sí' : 'No'}</td>
    </tr>`
    )
    .join('')
}

export const buildTopDenunciantesSimpleRows = (data) => {
  if (!data || data.length === 0) {
    return `<tr><td colspan="5" class="empty-msg">No se registran denunciantes para el período seleccionado.</td></tr>`
  }
  return data
    .map(
      (r, i) => `
    <tr class="${i % 2 === 1 ? 'alt' : ''}">
      <td>${r.cuil ?? ''}</td>
      <td>${r.nombre ?? ''}</td>
      <td class="r">${r.cantidad ?? ''}</td>
      <td class="r">${r.juicios ?? ''}</td>
      <td>${r.activo ? 'Sí' : 'No'}</td>
    </tr>`
    )
    .join('')
}
